import AppStorePngW from '../../assets/img/app_store_white.png';
import PosDownloadLogo from '../../assets/img/pos_download_logo.png';

import './index.css';
import './responsive.css';

function StoriesSection() {
  return (
    <div className="download-banner-JUZYnQ">
      <div className="white_-box-1O8qki"></div>

      <div className="download-wrapper">
        <div className="pos-logo">
          <img className="pos-logo-img" src={PosDownloadLogo} />
        </div>

        <div className="pos-text">
          <div className="pos-title">
            Download <span className="bold-title">DEMO PresentationOS</span>
          </div>

          <div className="pos-subtitle">
            Best experienced on an iPad 8th Gen <span>(2020) or newer models.</span>
          </div>
        </div>

        <div onClick={() => { window.open("https://apps.apple.com/us/app/demo-presentationos/id1607998050", '_blank'); }} className="app-store-1O8qki">
          <img className="download-app-store" src={AppStorePngW} />
        </div>
      </div>
    </div>
  );
}

export default StoriesSection;